:host{display:block;width:100%;height:100%}svg{width:100%;height:100%}
/*# sourceMappingURL=vector-renderer.component.css.map */
